<template>
  <div id="Landing">
    <div class="wrapper">
      <div class="content">
        <div class="name">
          <h2>
            Welcome
            {{
              clientName.length < 1
                ? "Rays Fan"
                : clientName.replace(/%20/g, " ")
            }}
          </h2>
        </div>
        <div class="bottom">
          <div class="left">
            <div class="repInfo">
              <div class="avatar">
                <img :src="getRepAvatar" alt="" />
              </div>
              <div class="text">
                <p>
                  <span class="title"> {{ repTitle }}</span>
                  {{ repName }}<span> | </span>{{ repPhone }}
                </p>
                <p>
                  <a :href="`mailto:` + repEmail">{{ repEmail }}</a>
                </p>
              </div>
            </div>
            <div class="countDown">
              <div class="date">
                <p>Countdown to Opening Day</p>
                <span>28 March 2024</span>
              </div>
              <CountDown
                :startDate="new Date()"
                endDate="March 28, 2024 16:10:00"
              />
            </div>
          </div>
          <div class="right">
            <div
              class="video"
              :style="{
                height: '647px',
              }"
            >
              <b-button v-b-modal.modal-1>
                <img src="@/assets/images/landing/play.svg" alt=" " />
                <div class="overlay"></div>
              </b-button>
            </div>
            <!-- <div class="auto-renew" v-if="traditionalOrFlex === 'Traditional'">
              <h5>2023 Membership</h5>
              <h3>auto-renewal on 12 sep 2022</h3>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-1" size="xl" hide-footer hide-header>
      <div class="videoWrapper">
        <vueVimeoPlayer
          :video-id="videoID"
          :options="options"
          @ready="onReady"
          ref="player"
        ></vueVimeoPlayer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { vueVimeoPlayer } from "vue-vimeo-player";
import { mapState } from "vuex";
import CountDown from "@/components/global/Countdown";
export default {
  name: "Landing",
  components: {
    CountDown,
    vueVimeoPlayer,
  },
  data() {
    return {
      videoID: "928527598",
      options: {
        background: true,
        muted: false,
      },
      playerReady: false,
      name: null,
      credit: null,
      bonus: null,
      //rep: this.$store.state.epitch.getRep,
      //repEmail: null,
      //repPhone: null,
      reps: ["Kenzie Dill", "Emilee Bell", "Matt Gianoni", "Megan Paul"],
      clientName: this.$store.state.epitch.getClient.name,
      repName: this.$store.state.epitch.getRep.first,
      repEmail: this.$store.state.epitch.getRep.email,
      repPhone: this.$store.state.epitch.getRep.phone,
      repTitle: this.$store.state.epitch.getRep.position,
    };
  },
  computed: {
    ...mapState(["global"]),
    getRepAvatar() {
      if (!this.$store.state.epitch.getRep.first)
        return require("@/assets/images/Rays_circleLogo.svg");
      switch (this.$store.state.epitch.getRep.first) {
        case "Jeff Tanzer":
          return require("@/assets/images/Rays_circleLogo.svg");

        case "Dan Newhart":
          return require("@/assets/images/reps/Dan-Newhart.png");

        case "Jeane Drury":
          return require("@/assets/images/reps/Drury_Jeane.png");

        case "Ryan Sullivan":
          return require("@/assets/images/reps/Sullivan.png");

        case "Carson Echelmeyer":
          return require("@/assets/images/reps/Echelmeyer_Carson.png");

        case "Daniel Schonborn":
          return require("@/assets/images/reps/Daniel_Schonborn.png");

        case "George Collins":
          return require("@/assets/images/reps/George_Collins.png");

        case "Taylor Roane":
          return require("@/assets/images/reps/Roane_Taylor.png");

        case "Rafael Lazala":
          return require("@/assets/images/reps/Lazala_Rafael.png");

        case "Zach Grundt":
          return require("@/assets/images/reps/Grundt_Zach.png");

        case "Alexa Restante":
          return require("@/assets/images/reps/Alexa_Restante.png");

        case "Victor Hagenbucher":
          return require("@/assets/images/Rays_circleLogo.svg");

        case "Brandon Harnick":
          return require("@/assets/images/reps/Brandon_Harnick.png");

        case "Jared Consiglio":
          return require("@/assets/images/reps/Consiglio_Jared.png");

        case "Jared Tomasso":
          return require("@/assets/images/reps/Tomasso_Jared.png");

        case "Lindsay Auld":
          return require("@/assets/images/reps/Auld_Lindsay.png");

        case "Matt Saccavino":
          return require("@/assets/images/reps/Saccavino_Matt.png");

        case "Eric Schwartz":
          return require("@/assets/images/reps/Schwartz_Eric.png");

        case "Lauren Mullen":
          return require("@/assets/images/reps/Mullen_Lauren.png");

        case "Brandon Wu":
          return require("@/assets/images/reps/Wu_Brandon.png");

        case "Josh Chriqui":
          return require("@/assets/images/reps/Chriqui_Josh.png");

        case "Elizabeth Perry":
          return require("@/assets/images/reps/Perry_Elizabeth.png");

        case "Paige Scharling":
          return require("@/assets/images/reps/Paige_Scharling.png");

        case "Tony Sudigala":
          return require("@/assets/images/reps/Tony_Sudigala.png");

        case "Dan Towne":
          return require("@/assets/images/reps/Dan_Towne.png");

        case "Michael Lombardo":
          return require("@/assets/images/reps/Michael_Lombardo.png");

        case "Jacob Parhamovich":
          return require("@/assets/images/reps/Jacob_Parhamovich.png");

        case "Frankie Pucci":
          return require("@/assets/images/reps/Frankie_Pucci.png");

        case "Heather Turner":
          return require("@/assets/images/reps/Heather_Turner.png");

        case "Hamid Noei":
        default:
          return require("@/assets/images/Rays_circleLogo.svg");
      }
    },
  },
  methods: {
    onReady() {
      this.playerReady = true;
      this.$refs.player.unmute();
    },
  },
  created() {
    let userInfo = this.$store.state.global.userInfo;
    this.name = userInfo.First_Name + " " + userInfo.Last_Name;
    this.credit = userInfo.Total_Credit;
    this.bonus = userInfo.totalBonus;
  },
};
</script>

<style lang="scss" scoped>
#Landing {
  background-image: url("~@/assets/images/landing/bgImage_hero_colour.jpeg");
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  position: relative;
  height: 1024px;
  /* background-size: 1440px; */
  background-color: #002962;
  padding-top: 80px;
  @media only screen and (max-width: $lg) {
    height: auto;
  }
  @media only screen and (max-width: $xl) {
    /* background-size: cover; */
  }
  @media only screen and (max-width: $sm) {
    /* padding: 200px 0 100px 0; */
  }
  .wrapper {
    display: flex;
    justify-content: center;
    padding: 0 20px;
  }
  .content {
    width: 100%;
    max-width: 1290px;

    @media only screen and (max-width: $lg) {
      padding: 20px 0;
      width: 517px;
    }
    @media only screen and (max-width: $sm) {
      width: 380px;
    }

    .name {
      background-image: url("~@/assets/images/landing/bgImage_hero_top.jpeg");
      background-size: cover;
      position: relative;
      margin-top: 82px;
      padding-inline: 40px;
      height: 116px;
      display: flex;
      align-items: center;
      justify-content: center;
      @media only screen and (max-width: $sm) {
        padding-inline: 20px;
        margin-top: 20px;
      }
      h2 {
        font-family: "Antique Olive Nord";
        font-style: normal;
        font-weight: 400;
        font-size: 50px;
        line-height: 46px;
        color: #00285e;
        text-align: center;
        @media only screen and (max-width: $xl) {
          font-size: 40px;
          line-height: 1;
        }
        @media only screen and (max-width: $lg) {
          font-size: 25px;
        }
      }
    }
    .bottom {
      display: flex;
      @media only screen and (max-width: $lg) {
        flex-direction: column-reverse;
      }
    }
    .left {
      background-image: url("~@/assets/images/landing/bgImage_hero_mid.jpeg");
      background-size: cover;
      width: 517px;
      height: 646px;
      @media only screen and (max-width: $sm) {
        zoom: 0.734;
      }
      .repInfo {
        width: 100%;
        height: 124px;
        display: flex;
        align-items: center;
        gap: 30px;
        .avatar {
          width: 100px;
          height: 100px;
          /* #logoRep {
          width: 100px;
        } */
          img {
            width: 100%;
            padding: 2px;
          }
        }
        .text {
          flex: 1;
          p,
          a {
            font-family: "Futura";
            font-style: normal;
            font-weight: 500;
            font-size: 18px;
            line-height: 24px;
            color: #161e26;
            &.noRep {
              margin-left: 0;
            }
            & > span.title {
              text-transform: uppercase;
              font-size: 0.9em;
              display: block;
              /* line-height: 1.2; */
            }
          }
        }
      }
      .countDown {
        margin-top: 316px;
        width: 100%;
        text-align: center;
        .date {
          height: 90px;
          display: flex;
          align-items: center;
          flex-wrap: nowrap;
          flex-direction: column;
          justify-content: center;
          p {
            font-family: "Antique Olive";
            font-style: normal;
            font-weight: 400;
            font-size: 20px;
            line-height: 25px;
            text-transform: uppercase;
            color: #dad9d7;
          }
          span {
            font-family: "Antique Olive";
            font-style: normal;
            font-weight: 700;
            font-size: 24px;
            line-height: 90%;
            text-transform: uppercase;
            color: #ffd200;
            display: block;
          }
        }
      }
    }
    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      .video {
        background-image: url("~@/assets/images/landing/video-bg.png");
        background-size: cover;
        background-position: center;
        /* height: 530px; */
        @media only screen and (max-width: $lg) {
          height: 250px !important;
        }
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn:focus {
          outline: none !important;
        }
        .btn:focus {
          box-shadow: none;
        }
        button {
          width: 110px;
          background: none;
          border: none;
          outline: none !important;
        }
        .overlay {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          background: #000;
          z-index: 0;
          opacity: 0.5;
        }
        img {
          position: relative;
          z-index: 1;
        }
      }
      .auto-renew {
        display: flex;
        padding: 20px 0;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        background-image: url("~@/assets/images/landing/bgImage_hero_bottom.jpeg");
        background-size: cover;
        flex: 1;
        h5,
        h3 {
          font-family: "Antique Olive";
          font-style: normal;
          font-weight: 700;

          line-height: 1;
          display: flex;
          align-items: center;
          text-align: center;
          text-transform: uppercase;
        }
        h5 {
          font-size: 24px;
          color: #79bde8;
          @media only screen and (max-width: $xl) {
            font-size: 18px;
          }
        }
        h3 {
          font-size: 35px;
          @media only screen and (max-width: $xl) {
            font-size: 20px;
          }
          color: #dad9d7;
        }
      }
    }
  }
}
</style>
<style lang="scss">
body {
  padding-right: 0px !important;
}
.videoWrapper {
  width: 100%;
  height: auto;
  /* height: 800px; */
  position: absolute;
  left: 0;
  right: 0;
  iframe {
    width: 100%;
    min-height: 640px;
    @media only screen and (max-width: $md) {
      min-height: 340px;
    }
  }
}

#modal-1 {
  .modal-content {
    background-color: transparent !important;
  }
  .modal-body {
    background-color: transparent !important;
  }
}

#modal-2 {
  .modal-content {
    font-family: "Futura" !important;
    background-color: #fff !important;
    p {
      margin: 15px 0 !important;
      color: $dark-blue !important;
      a {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .renewBtn {
      margin: 35px 0;
      a {
        font-family: "Futura";
        font-weight: 700;
        font-size: 16px;
        color: #000;
        background-color: $yellow;
        border-radius: 25px;
        padding: 15px 40px;
        text-transform: uppercase;
        cursor: pointer;
        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}

#modal-3,
#modal-traditional-invoice {
  .modal-content {
    font-family: "Futura" !important;
    background-color: #fff !important;
    p {
      margin: 15px 0 !important;
      color: $dark-blue !important;
      a {
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .renewBtn {
      margin: 35px 0;
      a {
        font-family: "Futura";
        font-weight: 700;
        font-size: 16px;
        color: #000;
        background-color: $yellow;
        border-radius: 25px;
        padding: 15px 40px;
        text-transform: uppercase;
        cursor: pointer;
        &:hover {
          text-decoration: none;
        }
      }
      button {
        font-family: "Futura";
        font-weight: 700;
        font-size: 16px;
        color: #000;
        background-color: $yellow !important;
        border-radius: 25px;
        padding: 13px 40px;
        text-transform: uppercase;
        width: 200px;
        cursor: pointer;
        &:hover {
          text-decoration: none;
        }
      }
      #selectInvoiceErr {
        color: #da3e3e;
        font-size: 14px;
        margin-top: 10px;
        margin-left: 5px;
        display: none;
      }
    }
    .invoiceOptions {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      @media only screen and (max-width: $md) {
        flex-direction: column;
      }

      .option {
        margin: 0 20px;
        label {
          @media only screen and (max-width: $lg) {
            font-size: 14px;
          }
        }
        input {
          margin-left: 5px;
        }
      }
    }
  }
}

#modal-4 {
  font-family: "Futura";
  h5 {
    font-family: "Futura";
    font-weight: 700;
    margin: 0;
  }
}
</style>
